export const jsExtensions = [
    '.mjs',
    '.cjs',
    '.js',
    '.mtsx',
    '.ctsx',
    '.tsx',
    '.mts',
    '.cts',
    '.ts',
];
